import React from 'react';
import styled from 'styled-components';
import { ApiStore, Subscribe } from 'Store';

import { toHumanReadable } from 'Libs/date';

import { Container, Header } from 'Components/core';
import { colors, layout } from 'Constants';
import AppleIcon from 'Icons/apple-alt.svg';
import StethoscopeIcon from 'Icons/stethoscope-alt.svg';
import HeartIcon from 'Icons/heart-alt.svg';
import PillsIcon from 'Icons/pills-alt.svg';
import { TitleHeader } from 'Components/core/Header';

const Dates=styled.div`
  display:flex;
  padding-bottom:12px;
`;

const InfoButtonPanel = styled.div`
  display: flex;

  width: 400px;
  padding-right: 64px;
  position: relative;
  justify-content: space-around;
`;

const Icon = styled.img`
  cursor: pointer;
  margin-bottom: -20px;
  height: 60px;
  width: 60px;
`;

const InfoContainer = styled(Container)`
  margin: 32px;
  @media screen and (max-width:400px) {
  margin:1px;
  }
  max-width: 500px;
  width: 100%;

  > div {
    padding:32px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    background-color: #fff;
    z-index: 2;

    > * {
      margin: 0;
    }

    > * + * {
      margin-top: 16px;
    }
  }

  position: relative;
  ::after,
  ::before {
    content: '';
    position: absolute;
    left: -24px;
    right: -24px;

    @media screen and (max-width:400px) {
      left: -0px;
    right: -0px;
  
    }
    
    background-color: ${colors.accent};
    height: 100%;
  }

  ::after {
    top: -24px;
  }

  ::before {
    top: calc(0% + 24px);
  }
`;

export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <InfoContainer column>
        <div>
          
          <TitleHeader style={{fontSize:'2em'}}>{state?.name}</TitleHeader>
          <Header>Welcome to {state?.networkName}</Header>
          <p style={{ fontSize: '0.9em' }}>
          As the new semester begins, we want to help you be
confident knowing you have the health coverage that's
right for you. The information on this site will guide
you through the {state?.networkName} plan,
explain coverage options and costs, and help you
make the most of your benefits.
          </p>
          {state?.datesToRemember && <p>
         
            <Dates>
          
              <div style={{width:250}}>
               
 
              </div>
            </Dates>
          </p>}
         
        </div>
      </InfoContainer>
    )}
  </Subscribe>
);
